import { Hand, calculate } from "./distance_"

export function distance(hand: Hand)
{
  return calculate(hand, Array(34).fill(0), 14, 0, 14)
}
